<template>
  <div id="app">
    <!-- 路由占位符 -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {}
  },
  components: {},
  mounted() {}
}
</script>

<style lang="less">
.el-input-number {
  i {
    line-height: 38px;
  }
}
.el-input-number--small {
  i {
    line-height: 30px;
  }
}
.el-input-number--mini {
  i {
    line-height: 26px;
  }
}
.el-table {
  /deep/ thead {
    tr {
      th {
        background-color: #f5f5f5 !important;
      }
    }
    color: #2f343c !important;
  }
}

.el-image {
  /deep/ .el-image-viewer__close {
    .el-icon-circle-close {
      color: #1b94ff;
    }
  }
}
</style>
